/* eslint-disable react/require-default-props */
import {Outlet} from "react-router-dom"
import Container from '@mui/material/Container';
import {DataStoreContextProvider} from "../contexts/OperatingEnvironmentContext";
import OperatingEnvironmentFuncTab from "../components/OperatingEnvironmentFuncTab";

export default function OperatingEnvironmentLayout() {
  return (
    <DataStoreContextProvider>
      <OperatingEnvironmentFuncTab/>
      <Container sx={{mx: 0, pb: 3, pt: 0, width: "100%", backgroundColor: 'white', maxWidth: "unset!important"}}>
        <Container sx={{mx: 0, pb: 3, pt: 1, width: "100%", backgroundColor: '#F6F7F8', maxWidth: "unset!important"}}>
          <Outlet/>
        </Container>
      </Container>
    </DataStoreContextProvider>
  )
}
